import {Injectable} from '@angular/core';

export type LocalStorageKey =
    'user'
    | 'session_expiration_time'
    | 'currentReport'
    | 'errorReportState'
    | 'activePage'
    | `sb-${string}-auth-token`

export interface LocalStorageItem {
    key: LocalStorageKey,
    value: string
}

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    getLocalStorageItem(key: LocalStorageKey): string | null {
        return localStorage.getItem(key)
    }

    saveToLocalStorage(storageItem: LocalStorageItem) {
        localStorage.setItem(storageItem.key, storageItem.value)
    }

    removeFromLocalStorage(key: LocalStorageKey) {
        localStorage.removeItem(key)
    }
}
